// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	SaveButton: 'save-button',
	AddNewOfficeButton: 'add-new-office-button',
	EditLetterheadButton: 'edit-letterhead-button',
	EditFooterButton: 'edit-footer-button',
	DeleteLogoButton: 'delete-logo-button',
	ViewLogoDiv: 'view-logo-div',
	LogoDropzone: 'logo-dropzone',
	OfficeContactCard: 'office-contact-card',
} as const;
